// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vwPw","newExpiryDate":"styles_newExpiryDate__3rEI8","footer":"styles_footer__1KlKl"};